var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { getHolidayThemeClassName } from '../utils/holidayThemes';
var HolidayGreetingBadge = function (_a) {
    var holiday = _a.holiday, _b = _a.size, size = _b === void 0 ? 'standard' : _b, _c = _a.mirroredIcons, mirroredIcons = _c === void 0 ? false : _c, _d = _a.className, className = _d === void 0 ? '' : _d;
    var themeClass = getHolidayThemeClassName('holiday-greeting-chip', holiday);
    var sizeClass = size === 'compact' ? 'holiday-greeting-chip--compact' : 'holiday-greeting-chip--standard';
    return (_jsxs("div", __assign({ className: "holiday-greeting-chip ".concat(themeClass, " ").concat(sizeClass, " ").concat(className).trim(), role: "status", "aria-label": "".concat(holiday.name, " greeting") }, { children: [_jsx("span", __assign({ className: "holiday-greeting-chip__icon", "aria-hidden": "true" }, { children: holiday.emoji })), _jsx("span", __assign({ className: "holiday-greeting-chip__text" }, { children: holiday.greeting })), mirroredIcons && (_jsx("span", __assign({ className: "holiday-greeting-chip__icon", "aria-hidden": "true" }, { children: holiday.emoji })))] })));
};
export default HolidayGreetingBadge;
